import http from '@services/http';
import { Metrics } from '$admin/api/interfaces';

export const fetchAggregate = (): Promise<Metrics.FetchAggregate.Response> => {
  return http.get(`/admin/metrics`);
};